/**
 * Google Analytics event names and helpers for the onboarding modal.
 *
 * @module platform/site-wide/onboarding-modal/analytics
 */

export const ONBOARDING_MODAL_EVENTS = {
  SHOWN: 'onboarding-modal-shown',
  LINK_CLICK: 'onboarding-modal-link-click',
  CLOSED: 'onboarding-modal-modal-closed',
  REQUEST_FAILED: 'onboarding-modal-request-failed',
};

export const ONBOARDING_MODAL_TITLE = 'What would you like to do first?';
export const ONBOARDING_MODAL_STATUS = 'info';

export const ONBOARDING_MODAL_REQUESTS = {
  CLAIMS: 'claims',
  ONBOARDING_DISPLAY: 'veteran-onboarding',
};

/**
 * Determines the close click label for the modal based on the DOM event that
 * VaModal `closeEvent` forwards in its `detail`.
 *
 * @param {CustomEvent} closeEvent The event passed to `onCloseEvent`.
 * @returns {string} 'x' when the X button was clicked, otherwise 'close'.
 */
export function getOnboardingModalCloseLabel(closeEvent) {
  const originalEvent = closeEvent?.detail;
  if (!originalEvent) return 'close';

  const path =
    typeof originalEvent.composedPath === 'function'
      ? originalEvent.composedPath()
      : [];
  const clickedCloseButton = path.some(node =>
    node?.classList?.contains?.('va-modal-close'),
  );
  if (clickedCloseButton) {
    return 'x';
  }

  return 'close';
}
